import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useBrand } from "@/contexts/BrandContext";

export type Branch = {
  id: string;
  name: string;
  nameAr: string;
  address: string;
  addressAr: string;
  phone: string;
  latitude: number | null;
  longitude: number | null;
  workingHours: string;
  workingHoursAr: string;
  is_open: boolean;
  is_busy: boolean;
  estimated_prep_time: number | null;
};

export function usePublicBranches() {
  const { brand } = useBrand();
  const [branches, setBranches] = useState<Branch[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!brand.id) return;
    const fetchBranches = async () => {
      setLoading(true);
      setError(null);
      const { data, error: err } = await supabase
        .from("branches")
        .select("*")
        .eq("restaurant_id", brand.id)
        .order("sort_order");

      if (err) {
        setError(err.message);
        setLoading(false);
        return;
      }

      setBranches(
        (data || []).map((b: any) => ({
          id: b.id,
          name: b.name,
          nameAr: b.name_ar || "",
          address: b.address || "",
          addressAr: b.address_ar || "",
          phone: b.phone || "",
          latitude: b.latitude,
          longitude: b.longitude,
          workingHours: b.working_hours || "",
          workingHoursAr: b.working_hours_ar || "",
          is_open: b.is_open ?? true,
          is_busy: b.is_busy ?? false,
          estimated_prep_time: b.estimated_prep_time ?? null,
        }))
      );
      setLoading(false);
    };
    fetchBranches();
  }, [brand.id]);

  return { branches, loading, error };
}
